import { useMutation } from "@tanstack/react-query";
import { deleteReviewer } from "PFCore/services/reviewers";
import { MutationOptions } from "PFTypes/request_options";

import { useActivityInvalidate } from "../activity";

export const useReviewerDelete = (
  activityId: number,
  { onSuccess, ...options }: MutationOptions<number> = {}
) => {
  const { invalidate: invalidateActivity } = useActivityInvalidate();

  return useMutation({
    mutationFn: (id: number) => deleteReviewer(id),
    onSuccess: (...params) => {
      invalidateActivity([activityId]);
      onSuccess?.(...params);
    },
    ...options
  });
};
